module.exports = __webpack_public_path__ + "img/nature_citrone_newer.cfc3531c.jpg";